<template>
    <a v-if="serienButtonUrl && serienButtonText" :title="serienButtonText" target="_blank" class="single__series-button" :href="serienButtonUrl">
        <span>{{serienButtonText}}</span>
        <i class="fa fa-angle-right"></i>
    </a>
</template>

<script>
    export default {
        computed:{
            serienButtonUrl(){
                if(typeof this.$store.getters.currentItemVariation.variationProperties !== 'undefined'){
                    if (this.$store.getters.currentItemVariation.variationProperties[0].properties.find(x => x.id === 4)){
                        return this.$store.getters.currentItemVariation.variationProperties[0].properties.find(x => x.id === 4).values.value.trim();
                    }
                }
                return null;
            },
            serienButtonText(){
                if (this.$store.getters.currentItemVariation.variationProperties[0].properties.find(x => x.id === 3)){
                    return this.$store.getters.currentItemVariation.variationProperties[0].properties.find(x => x.id === 3).values.value.trim();
                }
                return null;
            }
        }
    }
</script>
